export default __webpack_public_path__ + "static/media/PTSans-Bold.4597bd69.ttf";